import React, { memo, useEffect } from 'react';

import Logo from '@/components/Atom/Logo';
import Loader from '@/components/common/Loader';
import { useCheckGroup } from '@/components/hooks/customs/addressBook/useCheckGroup';
import AddGroup from '@/pages/main/components/addressLeftZone/groupList/addGroup/AddGroup.index';
import GroupListBottomIndex from '@/pages/main/components/addressLeftZone/groupList/bottom/GroupListBottom.index';
import { IGroupList } from '@/pages/main/components/addressLeftZone/groupList/GroupList.types';
import GroupListMidIndex from '@/pages/main/components/addressLeftZone/groupList/mid/GroupListMid.index';
import GroupListTopIndex from '@/pages/main/components/addressLeftZone/groupList/top/GroupListTop.index';
import { searchGroupOpenRecoil } from '@/recoil/atoms/addressBookGroup';
import { clickGroupNameRecoil } from '@/recoil/atoms/addressList';
import { groupBuddyListParamsRecoil, mainTableCheckDataFormatRecoil } from '@/recoil/atoms/mainTableRecoil';
import { activeGroupRecoil } from '@/recoil/atoms/softPhone';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import * as S from './GroupList.styles';
import SearchGroup from './searchGroup/SearchGroup.index';
import { mobileNavRecoil, windowWidthRecoil } from '@/recoil/atoms/router/mainRouterRecoil';
import { useWindowPopup } from '@/components/hooks/customs/windowPopup/useWindowPopup';
import { useNavigate } from 'react-router-dom';
import { customerRouterRecoil } from '@/recoil/atoms/customer/customer';

/**
 * @title 좌측 그룹 리스트 컴포넌트
 *
 * @author 정휘학
 * @since 2024.03.15
 * */
const GroupList = (props: IGroupList) => {
  // 015 api 연동 규격서로 보내기위한 recoil
  const navigate = useNavigate();
  const setCustomerRouterState = useSetRecoilState(customerRouterRecoil);
  const { selectAllS, toggleSelectAll, updateDeleteGroupList, checkedGroupListS } = useCheckGroup({
    groupList: props.groupList,
  });
  const [activeGroupS, setActiveGroupS] = useRecoilState(activeGroupRecoil);
  const [clickGroupName, setClickGroupName] = useRecoilState(clickGroupNameRecoil);
  // 메인 주소록 리스트 GET API Params
  const [groupBuddyListParamsS, setGroupBuddyListParamsS] = useRecoilState(groupBuddyListParamsRecoil);
  // 그룹 검색창 토글 Recoil
  const searchGroupOpenS = useRecoilValue(searchGroupOpenRecoil);

  const mobileNavState = useRecoilValue(mobileNavRecoil);

  const windowWidth = useRecoilValue(windowWidthRecoil);

  const popupHooks = useWindowPopup();

  const onClickGroupNm = (el: any) => {
    setActiveGroupS({
      groupNm: el?.groupNm ? el?.groupNm : null,
      groupSeqNo: el?.groupSeqNo ? el?.groupSeqNo : null,
      change: false,
    });
    setClickGroupName({ groupNm: el?.groupNm, groupSeqNo: el?.groupSeqNo });
    setGroupBuddyListParamsS((prevState) => {
      return {
        ...prevState,
        groupSeqNo: el?.groupSeqNo ? el?.groupSeqNo : null,
      };
    });
    props.setCheckedGroup(el?.groupSeqNo);
    if (typeof el?.groupSeqNo === 'number') {
      props.setGroupClickStyles(() => ({ [el?.groupSeqNo]: true }));
    } else {
      props.setGroupClickStyles({});
    }
    props.setOpenLargeToggle((prev: boolean) => !prev && false);
  };

  // 테이블 전체그룹 띄울시 (ex: 탭이동) 그룹리스트 스타일 변경
  useEffect(() => {
    if (groupBuddyListParamsS.groupSeqNo === null) {
      setClickGroupName(null);
    }
  }, [groupBuddyListParamsS]);
  // 수신인 클릭으로 인한 그룹리스트 스타일 변경
  useEffect(() => {
    if (activeGroupS?.change) {
      onClickGroupNm(activeGroupS);
    }
  }, [activeGroupS]);

  return (
    <>
      <S.Container
        id={'addressGrpList'}
        className={`addressGrpList ${props.resTableSwitchS ? 'active' : ''}`}
        isActive={mobileNavState === '주소록'}
      >
        {/* 로고 */}
        {windowWidth > 768 && <Logo eType="Reload" sType="B" />}
        {props.delLoadingS && <Loader backgroundToggle />}
        <S.Inner>
          <S.GroupListGroup className={`groupListGroup ${props.addGroupOpen || searchGroupOpenS ? 'active' : ''}`}>
            <GroupListTopIndex
              toggleSelectAll={toggleSelectAll}
              selectAll={selectAllS}
              onClickGroupNm={onClickGroupNm}
              groupList={props.groupList}
            />
            {props.addGroupOpen && (
              <AddGroup addGroupOpenHandle={props.addGroupOpenHandle} addGroupOpen={props.addGroupOpen} />
            )}
            {searchGroupOpenS && <SearchGroup />}
            <GroupListMidIndex
              groupList={props.groupList}
              clickGroupStyles={props.clickGroupStyles}
              clickStyle={props.clickStyle}
              updateDeleteGroupList={updateDeleteGroupList}
              checkedGroupListS={checkedGroupListS}
              onClickGroupNm={onClickGroupNm}
              childrenClickStyle={props.childrenClickStyle}
              groupListIsLoading={props.groupListIsLoading}
              clickGroupName={clickGroupName}
            />
          </S.GroupListGroup>
          {windowWidth > 768 && !props.groupListIsLoading && (
            <div className="bottomWrap">
              <GroupListBottomIndex
                groupList={props.groupList}
                recycleBinClickHandle={props.recycleBinClickHandle}
                binAllBtnState={props.binAllBtnState}
                deleteBinAllListOnClick={props.deleteBinAllListOnClick}
              />
              <button
                className="guide"
                onClick={() => popupHooks.openPopup({ url: '/helpContent', target: '_blank', size: '1' })}
              >
                이용가이드
              </button>
              {/* <button
                className="guide"
                onClick={() => {
                  popupHooks.openPopup({ url: '/015apiDoc', target: '_blank', size: '1' });
                  // navigate('/customer/-1');
                }}
              >
                015 API 연동 규격서
              </button> */}
            </div>
          )}
        </S.Inner>
        {/* <button className="openBtn" type="button" onClick={() => props.onClickGroupComponentToggle()}>
        <svg xmlns="http://www.w3.org/2000/svg" width="200" height="208" viewBox="0 0 200 208" fill="none">
          <path
            d="M59.19 150.4C60.0308 151.032 60.9879 151.492 62.0066 151.753C63.0253 152.015 64.0856 152.073 65.1268 151.925C66.168 151.776 67.1697 151.423 68.0745 150.887C68.9793 150.351 69.7696 149.642 70.4 148.8C75.2436 142.342 81.5244 137.1 88.7449 133.49C95.9654 129.88 103.927 128 112 128C120.073 128 128.035 129.88 135.255 133.49C142.476 137.1 148.756 142.342 153.6 148.8C154.23 149.64 155.02 150.349 155.924 150.884C156.828 151.419 157.829 151.771 158.869 151.92C159.909 152.068 160.968 152.01 161.985 151.75C163.003 151.489 163.96 151.03 164.8 150.4C165.64 149.77 166.349 148.98 166.884 148.076C167.419 147.172 167.771 146.171 167.92 145.131C168.068 144.091 168.01 143.032 167.75 142.015C167.489 140.997 167.03 140.04 166.4 139.2C159.315 129.703 149.869 122.226 139 117.51C144.957 112.071 149.13 104.959 150.973 97.106C152.815 89.253 152.24 81.0266 149.323 73.5062C146.407 65.9858 141.285 59.523 134.629 54.9657C127.974 50.4085 120.096 47.9699 112.03 47.9699C103.964 47.9699 96.0861 50.4085 89.4307 54.9657C82.7753 59.523 77.6532 65.9858 74.7365 73.5062C71.8199 81.0266 71.245 89.253 73.0873 97.106C74.9297 104.959 79.1031 112.071 85.06 117.51C74.1688 122.217 64.7011 129.695 57.6 139.2C56.3259 140.896 55.7776 143.029 56.0758 145.129C56.374 147.23 57.4942 149.125 59.19 150.4ZM88 88C88 83.2532 89.4076 78.6131 92.0447 74.6663C94.6819 70.7195 98.4302 67.6434 102.816 65.8269C107.201 64.0104 112.027 63.5351 116.682 64.4612C121.338 65.3872 125.614 67.673 128.971 71.0294C132.327 74.3859 134.613 78.6623 135.539 83.3178C136.465 87.9734 135.99 92.799 134.173 97.1844C132.357 101.57 129.28 105.318 125.334 107.955C121.387 110.592 116.747 112 112 112C105.635 112 99.5303 109.471 95.0294 104.971C90.5286 100.47 88 94.3652 88 88ZM184 0H40C35.7565 0 31.6869 1.68571 28.6863 4.68629C25.6857 7.68687 24 11.7565 24 16V40H8C5.87827 40 3.84344 40.8429 2.34315 42.3431C0.842854 43.8434 0 45.8783 0 48C0 50.1217 0.842854 52.1566 2.34315 53.6569C3.84344 55.1571 5.87827 56 8 56H24V96H8C5.87827 96 3.84344 96.8429 2.34315 98.3431C0.842854 99.8434 0 101.878 0 104C0 106.122 0.842854 108.157 2.34315 109.657C3.84344 111.157 5.87827 112 8 112H24V152H8C5.87827 152 3.84344 152.843 2.34315 154.343C0.842854 155.843 0 157.878 0 160C0 162.122 0.842854 164.157 2.34315 165.657C3.84344 167.157 5.87827 168 8 168H24V192C24 196.243 25.6857 200.313 28.6863 203.314C31.6869 206.314 35.7565 208 40 208H184C188.243 208 192.313 206.314 195.314 203.314C198.314 200.313 200 196.243 200 192V16C200 11.7565 198.314 7.68687 195.314 4.68629C192.313 1.68571 188.243 0 184 0ZM184 192H40V16H184V192Z"
            fill="currentColor"
          />
        </svg>
      </button> */}

        {/* 수신인 카운트 수가 1이상이면 표출 */}
      </S.Container>
    </>
  );
};

export default memo(GroupList);
